import { useMemo, Accordion } from 'external/react'

import ButtonBack from 'components/ButtonBack'

import usePublic from 'context/public-context/hook'

export default function CourseDetail () {

	const {courseInDetails: course} = usePublic()

	const units = useMemo(() => course.units || [], [course.units])

	return (
		<div className='container_course_detail'>
			<div className='body_course_detail'>
				<div className='bodyHeader_course_detail'>
					<div className='bodyHeaderTitle_course_detail'>
						<ButtonBack path={-1} />
						<p style={{ margin: '0' }}>{course.name}</p>
					</div>
					<div className='bodyHeaderActions_course_detail'>
						<span
							className='badge text-bg-primary d-flex justify-content-center align-items-center'
							style={{ height: '40px', width: '100px', fontSize: '14px' }}
						>
							{course.number_lessons} lecciones
						</span>
					</div>
				</div>
				<div className='bodyList_course_detail'>
					<Accordion defaultActiveKey='0'>
						{units.map((course, index) => {
							return (
								<Accordion.Item eventKey={index.toString()} key={index}>
									<Accordion.Header>
										Unidad {index + 1}: {course.name}
									</Accordion.Header>
									<Accordion.Body>
										<div className='bodyListItem_course_detail'>
											{course.lessons.map((lesson) => (
												<p key={lesson.id}>
													{lesson.id}: {lesson.name}
												</p>
											))}
										</div>
									</Accordion.Body>
								</Accordion.Item>
							)
						})}
					</Accordion>
				</div>
			</div>
		</div>
	)
}